import { apiClient } from './api';

export interface QuoteRow { role: string; level: string; people: number; months: number; rate: number; utilization: number; note?: string }
export interface QuoteInput { date: string; client: string; title: string; rows: QuoteRow[]; expenseRate: number; research: number; amount: number }
export interface InvoiceBase { date: string; client: string; address: string; contact: string; vatIncluded: boolean }
export interface BillingItem { name: string; ratio: number; dueDate: string; amount: number }
export interface UpcomingBilling { projectId: number; projectName: string; clientName: string; name: string; dueDate: string; amount: number; overdue: boolean }

/** 견적서(06.견적) · 거래명세서(05.정산) — 서버 `modules/quote` */
export const quoteApi = {
  quoteDraft: (id: number): Promise<QuoteInput & { rateCard: Record<string, number> }> => apiClient.get(`/projects/${id}/quote/draft`),
  quote: (id: number, q: QuoteInput): Promise<{ fileName: string; url: string; total: number; writeOff: number }> => apiClient.post(`/projects/${id}/quote`, q),
  invoiceDraft: (id: number): Promise<{ base: InvoiceBase; schedule: BillingItem[] }> => apiClient.get(`/projects/${id}/invoice/draft`),
  invoice: (id: number, body: InvoiceBase & { items: { date: string; name: string; qty: number; unit: number; note: string }[] }): Promise<{ fileName: string; url: string; total: number }> =>
    apiClient.post(`/projects/${id}/invoice`, body),
  upcoming: (days = 30): Promise<UpcomingBilling[]> => apiClient.get(`/billing/upcoming?days=${days}`),
};

/** 계약서 초안(03.계약서) · 실적증명서 초안(04.산출물/실적증명) — 기본값을 받아 고친 뒤 만든다 */
export type DraftKind = 'contract' | 'certificate';
export const draftApi = {
  get: (id: number, kind: DraftKind): Promise<Record<string, unknown>> => apiClient.get(`/projects/${id}/${kind}/draft`),
  make: (id: number, kind: DraftKind, body: Record<string, unknown>): Promise<{ fileName: string; url: string }> => apiClient.post(`/projects/${id}/${kind}`, body),
};
